import { RecordUtils } from "andculturecode-javascript-core";
import { Record } from "immutable";
import { HubspotFormSubmission } from "models/interfaces/hubspot/hubspot-form-submission";
import { CollectionUtils } from "utilities/collection-utils";
import HubspotFormSubmissionFieldRecord from "./hubspot-form-submission-field-record";

const defaultValues: HubspotFormSubmission = {
    fields: [],
    portalId: 0,
};

export default class HubspotFormSubmissionRecord
    extends Record(defaultValues)
    implements HubspotFormSubmission
{
    // -----------------------------------------------------------------------------------------
    // #region Constructor
    // -----------------------------------------------------------------------------------------

    constructor(params?: HubspotFormSubmission) {
        if (params == null) params = Object.assign({}, defaultValues);
        if (CollectionUtils.hasValues(params.fields)) {
            params.fields = params.fields.map((r) =>
                RecordUtils.ensureRecord(r, HubspotFormSubmissionFieldRecord)
            );
        }

        super(params);
    }

    // #endregion Constructor

    /**
     * Returns new object based on `this` and merges the partial values
     * @param  {Partial<HubspotFormSubmission>} values
     * @returns HubspotFormSubmissionRecord
     */
    public with(values: Partial<HubspotFormSubmission>): HubspotFormSubmissionRecord {
        return new HubspotFormSubmissionRecord(
            Object.assign(this.toJS(), values) as HubspotFormSubmissionRecord
        );
    }
}
